import { render } from "./NineLayout.vue?vue&type=template&id=6391b5a8&scoped=true"
import script from "./NineLayout.vue?vue&type=script&lang=js"
export * from "./NineLayout.vue?vue&type=script&lang=js"

import "./NineLayout.vue?vue&type=style&index=0&id=6391b5a8&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6391b5a8"]])

export default __exports__